import React from 'react';
import { toggleWarning } from '../gui/actions';
import { connect } from 'react-redux';
import classnames from 'classnames';
import * as _ from 'lodash';

class SingleWarning extends React.Component {
	render() {
		const { toggleWarning, name, warnings } = this.props;
		return (
			<li
				onClick={() => toggleWarning(name, !warnings[name])}
				className={classnames('single-warning', {'single-warning--active': warnings[name]})} >
				{_.startCase(name)}
			</li>
		);
	}
}

const mapStateToProps = state => ({
	warnings: state.gui.warnings,
})

const mapDispatchToProps = dispatch => ({
	dispatch,
	toggleWarning(name, bool) {
		dispatch(toggleWarning(name, bool))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(SingleWarning);


// WEBPACK FOOTER //
// ./src/diets/SingleWarning.js